export default "__VITE_ASSET__DMoGGjU4__"